"use client";

import { useRef } from "react";
import styles from "./home.module.css";

// "Questions? Read the FAQ" and the sheet it opens. A modal <dialog>, so Esc
// closes it natively; the close button and a click on the backdrop do too.
// While closed the dialog is display: none, so it adds nothing to the column's gap.

const FAQ = [
  { q: "Is there a contract?", a: "No. Sevra is month to month, and you can cancel whenever you like." },
  { q: "Who owns our guest data?", a: "You do. Export your full guest list at any time, without asking us." },
  {
    q: "How does setup work if we're coming from OpenTable?",
    a: "You set everything up yourself: draw your floor plan, add your tables and hours, and share your booking link. To bring your guests over, export your list from OpenTable GuestCenter and import the CSV in Settings. Most restaurants finish in one evening and keep their current system running until they're ready to switch.",
  },
  { q: "Are text messages included?", a: "Yes. SMS confirmations and two-way messages with guests are part of the monthly price." },
  {
    q: "What does support look like?",
    a: (
      <>
        You talk directly to the people who build Sevra. Write to <span className={styles.addr}>contact@sevra.ca</span> and
        we&apos;ll answer.
      </>
    ),
  },
  { q: "Are you a Canadian company?", a: "Yes. Sevra is built and run in Canada, and priced in Canadian dollars." },
];

export default function FaqDialog() {
  const dialogRef = useRef<HTMLDialogElement>(null);

  function open() {
    const faq = dialogRef.current!;
    try {
      faq.showModal();
    } catch {
      faq.setAttribute("open", "");
    }
  }

  function close() {
    const faq = dialogRef.current!;
    if (faq.close) faq.close();
    else faq.removeAttribute("open");
  }

  return (
    <>
      <button className={styles.faqLink} type="button" onClick={open}>
        Questions? Read the FAQ
      </button>
      <dialog
        ref={dialogRef}
        className={styles.faq}
        aria-labelledby="faq-title"
        onClick={(e) => {
          if (e.target === e.currentTarget) close();
        }}
      >
        <div className={styles.faqHead}>
          <div className={styles.faqTitle}>
            <span className={styles.priceLabel}>FAQ</span>
            <h2 id="faq-title">Questions, answered.</h2>
          </div>
          <button className={styles.x} type="button" aria-label="Close FAQ" onClick={close}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
              <path d="M2 2l10 10M12 2 2 12" />
            </svg>
          </button>
        </div>
        <div className={styles.faqList}>
          {FAQ.map((item) => (
            <details key={item.q}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </dialog>
    </>
  );
}
